import { EarthIcon } from '../../../svg/earth-icon';
import { ComboboxModel } from '../../combobox/combobox-model';
import { TIME_ZONE_OPTIONS } from '../constants';

interface TimeZoneSelectProps {
  disabled?: boolean;
  id?: string;
  value: string;
  onChange: (timeZone: string) => void;
}

/** Time zone picker. Always includes the current `value` even if it's outside the curated list. */
export function TimeZoneSelect({ disabled = false, id, value, onChange }: TimeZoneSelectProps) {
  const hasCurrentValue = TIME_ZONE_OPTIONS.some((option) => option.value === value);
  const model = hasCurrentValue
    ? TIME_ZONE_OPTIONS
    : [...TIME_ZONE_OPTIONS, { value, label: value }];

  return (
    <div className="flex items-center gap-2">
      <EarthIcon className="mb-[2px] shrink-0" />
      <ComboboxModel
        className="flex-1 px-1 text-muted-foreground [&_svg]:invisible"
        disabled={disabled}
        id={id}
        model={model.map((option) => ({
          value: option.value,
          item: option.label,
          key: option.value.concat(option.label),
        }))}
        size="xs"
        variant="link"
        value={value}
        onSelect={onChange}
      />
    </div>
  );
}
